import { useCallback } from "react";
import { useSWRConfig } from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import useLoading, { UseLoadingReturn } from "@/hooks/use-loading";
import { AccountAnticipationConfiguration } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";

export type UseUpdateAccountAnticipationReturn = {
  update: (creditCardAutomaticEnabled: boolean) => Promise<AccountAnticipationConfiguration>;
} & UseLoadingReturn;

const useUpdateAccountAnticipation = (): UseUpdateAccountAnticipationReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon } = useLoading();
  const { mutate } = useSWRConfig();

  const update = useCallback(
    async (creditCardAutomaticEnabled: boolean): Promise<AccountAnticipationConfiguration> => {
      startLoading();
      try {
        const result = await t2payService.updateAccountAnticipation({
          creditCardAutomaticEnabled,
        });
        await mutate(SWR_KEYS.getAccountAnticipation, result, { revalidate: false });
        return result;
      } finally {
        endLoading();
      }
    },
    [endLoading, mutate, startLoading]
  );

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdateAccountAnticipation;
